import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const NewsletterUnsubscribeFormValidationSchema = yup.object({
    email: RHFUserValidationRules.email
});

export type NewsletterUnsubscribeFormValues = yup.InferType<
    typeof NewsletterUnsubscribeFormValidationSchema
>;
